// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserPresentationTemplateTableQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type UserPresentationTemplateTableQuery = { __typename?: 'Query', presentationTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & UserPresentationTemplateTable_PresentationTemplateFragment
      ) | null } | null> | null } };

export type UserPresentationTemplateTable_PresentationTemplateFragment = { __typename?: 'PresentationTemplate', id: string, displayName: string, createdAt: Time, updatedAt: Time };

export const Operations = {
  Query: {
    UserPresentationTemplateTable: 'UserPresentationTemplateTable' as const
  },
  Fragment: {
    UserPresentationTemplateTable_PresentationTemplate: 'UserPresentationTemplateTable_PresentationTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const UserPresentationTemplateTable_PresentationTemplateFragmentDoc = gql`
    fragment UserPresentationTemplateTable_PresentationTemplate on PresentationTemplate {
  id
  displayName
  createdAt
  updatedAt
}
    `;
export const UserPresentationTemplateTableDocument = gql`
    query UserPresentationTemplateTable($userId: ID!) {
  presentationTemplates(
    where: {and: [{type: USER_TEMPLATE}, {hasUserWith: [{id: $userId}]}, {systemTemplateKindIsNil: true}]}
  ) {
    edges {
      node {
        ...UserPresentationTemplateTable_PresentationTemplate
      }
    }
  }
}
    ${UserPresentationTemplateTable_PresentationTemplateFragmentDoc}`;

/**
 * __useUserPresentationTemplateTableQuery__
 *
 * To run a query within a React component, call `useUserPresentationTemplateTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPresentationTemplateTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPresentationTemplateTableQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPresentationTemplateTableQuery(baseOptions: Apollo.QueryHookOptions<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>(UserPresentationTemplateTableDocument, withFetchPolicyContext(options));
      }
export function useUserPresentationTemplateTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>(UserPresentationTemplateTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useUserPresentationTemplateTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>(UserPresentationTemplateTableDocument, withFetchPolicyContext(options));
        }
export type UserPresentationTemplateTableQueryHookResult = ReturnType<typeof useUserPresentationTemplateTableQuery>;
export type UserPresentationTemplateTableLazyQueryHookResult = ReturnType<typeof useUserPresentationTemplateTableLazyQuery>;
export type UserPresentationTemplateTableSuspenseQueryHookResult = ReturnType<typeof useUserPresentationTemplateTableSuspenseQuery>;
export type UserPresentationTemplateTableQueryResult = Apollo.QueryResult<UserPresentationTemplateTableQuery, UserPresentationTemplateTableQueryVariables>;